// extracted by mini-css-extract-plugin
export default {"PostDetailRight__searchPanel":"qw_a bib_sw bib_kx bib_ky","PostDetailRight__brandDaysPosts":"qw_b bib_sw bib_kx bib_ky"};